import { MessageDTO } from '../../../types';
import { MessageEventMap } from './constants';
import { MessageEventType, IMessageEvent } from '../types/trip';

export const transformEventCode = (event: MessageDTO): IMessageEvent => {
  let code: '' | MessageEventType = '';
  if (event.eventId === MessageEventMap.GREEN_DRIVING_TYPE) {
    if (event.event?.value === 1) {
      code = MessageEventType.HARSH_ACCELERATION;
    }
    if (event.event?.value === 2) {
      code = MessageEventType.HARSH_BRAKING;
    }
  }
  if (event.eventId === MessageEventMap.OVER_SPEEDING) {
    code = MessageEventType.OVER_SPEEDING;
  }
  return {
    ...event,
    code: code as MessageEventType,
    id: crypto.randomUUID(),
  };
};
